import type { AppContext } from '@cruz/shared';
import { useEffect, useState } from 'react';
import { fetchContext } from '../lib/api.ts';

const REFRESH_MS = 5 * 60_000;

/** Date, season and simulated-clock flag from the server, refreshed every few minutes. */
export function useAppContext(): AppContext | null {
  const [ctx, setCtx] = useState<AppContext | null>(null);
  useEffect(() => {
    const abort = new AbortController();
    const refresh = () =>
      fetchContext(abort.signal).then(setCtx, () => {
        // Offline or server down: keep what we had; suggestions fall back to generic ones
      });
    void refresh();
    const timer = setInterval(() => void refresh(), REFRESH_MS);
    return () => {
      abort.abort();
      clearInterval(timer);
    };
  }, []);
  return ctx;
}
